export default {
  title: 'CÀI ĐẶT',

  radioButtonTitle: {
    vi: 'Tiếng Việt',
    en: 'English',
    Dark: 'Nền Tối',
    Light: 'Nền Sáng',
    Small: 'Nhỏ',
    Medium: 'Vừa',
    Large: 'Lớn',
    1: 'Hiệu năng',
    2: 'Dữ liệu',
  },

  listTab: {
    general: 'CÀI ĐẶT CHUNG',
    notifications: 'THÔNG BÁO',
    contact: 'LIÊN HỆ',
  },

  saveButton: 'LƯU',

  listTitleGeneral: {
    language: 'Ngôn Ngữ',
    intraday: 'Intraday',
    theme: 'Chủ Đề',
    textSize: 'Cỡ Chữ',
    timeZone: 'Múi giờ',
    format: 'Định dạng',
    sample: 'Ví dụ',
    date: 'Ngày',
    time: 'Giờ',
  },
  nodificationPlatform: 'Nền Tảng',
  notificationTitle: 'Lựa chọn Email',

  listRadioNotification: {
    NOTIFICATION_SUBSCRIBE: 'Tôi muốn nhận thông báo từ FiinTrade',
    NOTIFICATION_UNSUBSCRIBE: 'Tôi không muốn nhận thông báo',
  },

  listCheckboxNotification: {
    newsEmailSubscribed:
      'Tôi muốn nhận thông tin về tin tức và cập nhật của FiinTrade',
    notificationEmailSubscribed:
      'Tôi muốn nhận thông báo của các sự kiện giao dịch qua email cá nhân',
  },

  listTitleContact: {
    customerService: 'Hỗ trợ Khách Hàng',
    customerServicesPage: 'Trang Hỗ Trợ Khách Hàng',
    userData: 'Dữ liệu người dùng',
    lastLoginAttempt: 'Lần đăng nhập gần nhất',
    lastLoginStatus: 'Trạng thái đăng nhật',
    softwareInformation: 'Thông tin phần mềm',
    version: 'Phiên Bản',
    system: 'Hệ Thống',
  },

  userInfo: {
    title: 'Thông tin cá nhân',
    myProfile: 'Thông tin của tôi',
    changePassword: 'Thay đổi mật khẩu',
    emailAddress: 'Địa chỉ email',
    mobileNumber: 'Số điện thoại',
    preferenceContact: 'Liên hệ ưa thích',
    button: {
      save: 'Lưu',
      cancel: 'Hủy',
    },
    memberShip: 'Thành viên',
    usingAcc: 'Bạn đang sử dụng ',
    endAcc: 'Sử dụng đến ',
    reNew: 'Mua tiếp',
    upgrade: 'Nâng cấp',

    email: 'Email',
    mobilephone: 'Di động',
  },
  'English (UK)': 'Tiếng Anh (UK)',
};
